import { MetricsTracker, USER_EVENTS, generateMetricsAttribute } from '@sm/metrics';
import { AMPLITUDE_PAGE_EVENTS, AMPLITUDE_SELECTED_PACKAGE_MAP } from '~shared/util';
import { CTAClickEventType, PageEventLoadType } from './types';

const PRICINGWEB = 'pricingweb';

export function logPricingPageLoad({ pageName, utSource }: PageEventLoadType): void {
  if (!pageName) {
    return;
  }

  // async this to not block main thread
  setTimeout(() => {
    MetricsTracker.track({
      name: USER_EVENTS.PAGE_VIEW,
      data: {
        actionType: USER_EVENTS.PAGE_VIEW,
        actionFlow: pageName,
        amplitudeEvent: AMPLITUDE_PAGE_EVENTS.pageView,
        pageName,
        upgradeTriggerSource: utSource,
        source: PRICINGWEB,
      },
    });
  }, 0);
}

export function generateCTAMetricsAttribute({ pageName, packageId, packageName }: CTAClickEventType): String {
  return generateMetricsAttribute({
    name: USER_EVENTS.ELEMENT_INTERACTION,
    data: {
      actionType: USER_EVENTS.ELEMENT_INTERACTION,
      actionFlow: pageName,
      amplitudeEvent: AMPLITUDE_PAGE_EVENTS.selectedPlans,
      pageName,
      selectedPackageId: packageId,
      selectedPackageName: AMPLITUDE_SELECTED_PACKAGE_MAP[packageName] ?? packageName.toLowerCase(),
      source: PRICINGWEB,
    },
  });
}
